import React from 'react';
import { Box } from '@chakra-ui/core';

const Section = ({ children }) => {
    return <Box margin={['20px', '40px 0 40px 100px']}>{children}</Box>;
};

export default Section;